export default {
  get(key) { return localStorage.getItem(key) },
  set(key, e) { localStorage.setItem(key, e) },

  getLiveToken() { return this.get('liveToken') },
  setLiveToken(token) { return this.set('liveToken', token) },

  getUser() {
    const res = localStorage.getItem('userInfo')
    try {
      return JSON.parse(res)
    } catch (e) {
      return {}
    }
  },

  setUser(userInfo) {
    const user = {
      userId: userInfo.userId,
      code: userInfo.code,
      userNick: userInfo.appNickName,
      head: userInfo.head,
      storeId: userInfo.storeId,
    }
    localStorage.setItem('userInfo', JSON.stringify(user))
  },

  getUserPermissions() {
    const res = this.get('userPermissions')
    if (!res) {
      return null
    }
    try {
      return JSON.parse(res)
    } catch (e) {
      return []
    }
  },

  setUserPermissions(permissions) {
    if (!permissions) {
      localStorage.removeItem('userPermissions')
      return
    }
    try {
      const res = JSON.stringify(permissions)
      localStorage.setItem('userPermissions', res)
    } catch (e) {
    }
  },

  getStaffMenuList() {
    const res = localStorage.getItem('staffMenuList')
    try {
      return JSON.parse(res)
    } catch (e) {
      return []
    }
  },
  setStaffMenuList(menuList) {
    if (!menuList) {
      localStorage.removeItem('staffMenuList')
      return
    }
    try {
      const res = JSON.stringify(menuList)
      localStorage.setItem('staffMenuList', res)
    } catch (e) {
    }
  },
}



// WEBPACK FOOTER //
// ./src/util/local.js